

// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { createTaskTitle } from "../redux/actions/tasksTitleActions";

// const CreateTaskTitle = () => {
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [priority, setPriority] = useState("high");

//   const dispatch = useDispatch();
//   const { creating, error } = useSelector((state) => state.tasksTitle);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!title || !description) return;

//     dispatch(createTaskTitle(title, description, priority));
//     setTitle("");
//     setDescription("");
//     setPriority("high");
//   };

//   return (
//     <div className="w-full h-auto bg-gray-100 p-4">
//       <div className="max-w-xl mx-auto bg-white p-6 rounded-lg shadow-lg">
//         <h1 className="text-2xl font-bold mb-4">Create Task Title</h1>

//         {error && (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
//             Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div>
//             <label className="block mb-1 font-medium">Title</label>
//             <input
//               placeholder="Enter Task Title"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               className="w-full border border-gray-300 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//               required
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium">Description</label>
//             <textarea
//               placeholder="Enter Description"
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               className="w-full border border-gray-300 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//               required
//               rows={3}
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium">Priority</label>
//             <select
//               value={priority}
//               onChange={(e) => setPriority(e.target.value)}
//               className="w-full border border-gray-300 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="high">High</option>
//               <option value="medium">Medium</option>
//               <option value="low">Low</option>
//             </select>
//           </div>

//           <button
//             type="submit"
//             disabled={creating}
//             className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
//           >
//             {creating ? "Creating..." : "Create Task Title"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CreateTaskTitle;


import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createTaskTitle } from "../redux/actions/tasksTitleActions";

const CreateTaskTitle = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("high");

  const dispatch = useDispatch();
  const { creating, error } = useSelector((state) => state.tasksTitle);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title || !description) return;

    dispatch(createTaskTitle(title, description, priority));
    setTitle("");
    setDescription("");
    setPriority("high");
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Task Title</h1>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
            Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Title */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Title</label>
            <input
              type="text"
              placeholder="Enter task title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
              required
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Description</label>
            <textarea
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
              required
            />
          </div>

          {/* Priority */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Priority</label>
            <select
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
            >
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={creating}
            className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
              creating
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {creating ? "Creating..." : "Create Task Title"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateTaskTitle;
